import { Lock, X, Check } from "lucide-react";

const ReauthForm = ({
	reauthPassword,
	setReauthPassword,
	onCancel,
	onSubmit,
	translate,
	isLoading = false,
}) => {
	return (
		<div className="reauth-modal-content glass-effect">
			<div className="settings-title-container">
				<Lock size={20} />
				<h2>{translate("reauth.title")}</h2>
			</div>
			<form onSubmit={onSubmit}>
				<div className="layout-row design-form">
					<label htmlFor="password" className="reauth-label">
						{translate("reauth.description")}
					</label>
					<input
						id="password"
						type="password"
						value={reauthPassword}
						onChange={e => setReauthPassword(e.target.value)}
						placeholder={translate("reauth.placeholder")}
						className="field"
						required
						disabled={isLoading}
					/>
				</div>
				<div className="ios-buttons">
					<button
						type="button"
						onClick={onCancel}
						className="ios-button"
						disabled={isLoading}
					>
						<X size={18} />
						{translate("action.cancel")}
					</button>
					<button
						type="submit"
						className="ios-button action"
						disabled={isLoading || !reauthPassword.trim()}
					>
						<Check size={18} />
						{isLoading
							? translate("action.confirming")
							: translate("action.confirm")}
					</button>
				</div>
			</form>
		</div>
	);
};

export default ReauthForm;
